/*
 * chagual-inapp-browser.js
 * ------------------------------------------------------------------
 * Aviso "Abrí en tu navegador" para el navegador interno (in-app) de Meta
 * (Instagram / Facebook / Messenger). Ese ambiente es pobre para comprar
 * (sin autocompletar, fricción de pago) y baja la conversión.
 *
 * - Solo actúa dentro del in-app browser de Meta. En navegadores normales
 *   la detección corta de entrada y NO hace absolutamente nada.
 * - No bloqueante, dismissible, una vez por sesión.
 * - Vanilla JS, sin dependencias. Cargar con defer.
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  /* ===== COPY EDITABLE (Español de Chile, tono amable) ============ */
  var TEXTOS = {
    titulo: 'Compra más fácil en tu navegador',
    descripcion: 'Estás dentro de la app de Instagram/Facebook. Ábrela en tu navegador para pagar más rápido y con autocompletado.',
    botonAbrir: 'Abrir en mi navegador',
    botonCopiar: 'Copiar enlace',
    botonCopiado: '¡Enlace copiado!',
    instruccionIOS: 'Toca ••• (arriba a la derecha) y elige “Abrir en el navegador”.',
    cerrarAria: 'Cerrar aviso'
  };
  /* ================================================================ */

  var STORAGE_FLAG = 'chagual_inapp_dismissed';

  // 1) Detección: solo navegadores in-app de Meta.
  var ua = navigator.userAgent || '';
  var esMetaInApp = /(Instagram|FBAN|FBAV|FB_IAB|Messenger)/i.test(ua);
  if (!esMetaInApp) {
    return; // Navegador normal: no hacemos nada.
  }

  // 2) Una vez por sesión.
  try {
    if (sessionStorage.getItem(STORAGE_FLAG) === '1') {
      return;
    }
  } catch (e) {
    // sessionStorage no disponible: seguimos mostrando igual.
  }

  var esAndroid = /Android/i.test(ua);
  var esIOS = /(iPhone|iPad|iPod)/i.test(ua);

  function marcarCerrado() {
    try {
      sessionStorage.setItem(STORAGE_FLAG, '1');
    } catch (e) {}
  }

  // 3) Estilos propios con prefijo chagual-inapp- (sin chocar con nada).
  function inyectarEstilos() {
    if (document.getElementById('chagual-inapp-styles')) {
      return;
    }
    var css = [
      '.chagual-inapp-sheet{position:fixed;left:0;right:0;bottom:0;z-index:2147483600;',
      'background:#ffffff;color:#1a1a1a;border-top:1px solid #e3e3e3;',
      'box-shadow:0 -8px 24px rgba(0,0,0,.14);padding:16px 16px calc(16px + env(safe-area-inset-bottom,0px));',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;',
      'line-height:1.4;animation:chagual-inapp-up .25s ease-out;}',
      '@keyframes chagual-inapp-up{from{transform:translateY(100%)}to{transform:translateY(0)}}',
      '.chagual-inapp-row{display:flex;align-items:flex-start;gap:12px;}',
      '.chagual-inapp-body{flex:1 1 auto;min-width:0;}',
      '.chagual-inapp-title{font-size:15px;font-weight:700;margin:0 0 4px;}',
      '.chagual-inapp-desc{font-size:13px;color:#555;margin:0;}',
      '.chagual-inapp-actions{display:flex;flex-wrap:wrap;gap:8px;margin-top:12px;}',
      '.chagual-inapp-btn{appearance:none;border:0;border-radius:8px;padding:11px 16px;',
      'min-height:44px;font-size:14px;font-weight:600;cursor:pointer;line-height:1;}',
      '.chagual-inapp-btn--primary{background:#1a1a1a;color:#fff;flex:1 1 auto;}',
      '.chagual-inapp-btn--ghost{background:#f1f1f1;color:#1a1a1a;}',
      '.chagual-inapp-close{flex:0 0 auto;background:transparent;border:0;cursor:pointer;',
      'display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;',
      'font-size:22px;line-height:1;color:#888;padding:0;margin:-8px -8px 0 0;}',
      '.chagual-inapp-close:hover{color:#1a1a1a;}',
      '.chagual-inapp-btn:focus,.chagual-inapp-close:focus{outline:2px solid #1a1a1a;outline-offset:2px;}',
      '.chagual-inapp-btn:focus:not(:focus-visible),.chagual-inapp-close:focus:not(:focus-visible){outline:none;}',
      '.chagual-inapp-btn:focus-visible,.chagual-inapp-close:focus-visible{outline:2px solid #1a1a1a;outline-offset:2px;}',
      '@media (prefers-reduced-motion:reduce){.chagual-inapp-sheet{animation:none;}}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'chagual-inapp-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  // 4) Acciones.
  function abrirEnChromeAndroid() {
    try {
      var loc = window.location;
      var intentUrl = 'intent://' + loc.host + loc.pathname + loc.search +
        '#Intent;scheme=https;package=com.android.chrome;end';
      window.location = intentUrl;
    } catch (e) {
      // Si el intent falla, el usuario igual tiene el texto/instrucciones.
    }
  }

  function copiarEnlace(boton) {
    var href = window.location.href;
    function ok() {
      boton.textContent = TEXTOS.botonCopiado;
      setTimeout(function () {
        boton.textContent = TEXTOS.botonCopiar;
      }, 2000);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(href).then(ok, fallbackCopiar);
        return;
      }
    } catch (e) {}
    fallbackCopiar();

    function fallbackCopiar() {
      try {
        var ta = document.createElement('textarea');
        ta.value = href;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        ok();
      } catch (e) {}
    }
  }

  // 5) Construir el banner / hoja inferior.
  function construirBanner() {
    inyectarEstilos();

    var sheet = document.createElement('div');
    sheet.className = 'chagual-inapp-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-live', 'polite');
    sheet.setAttribute('aria-label', TEXTOS.titulo);

    var row = document.createElement('div');
    row.className = 'chagual-inapp-row';

    var body = document.createElement('div');
    body.className = 'chagual-inapp-body';

    var title = document.createElement('p');
    title.className = 'chagual-inapp-title';
    title.textContent = TEXTOS.titulo;

    var desc = document.createElement('p');
    desc.className = 'chagual-inapp-desc';
    desc.textContent = esIOS ? TEXTOS.instruccionIOS : TEXTOS.descripcion;

    body.appendChild(title);
    body.appendChild(desc);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'chagual-inapp-close';
    close.setAttribute('aria-label', TEXTOS.cerrarAria);
    close.innerHTML = '&times;';
    close.addEventListener('click', cerrar);
    document.addEventListener('keydown', cerrarConEscape);

    row.appendChild(body);
    row.appendChild(close);

    var actions = document.createElement('div');
    actions.className = 'chagual-inapp-actions';

    if (esAndroid) {
      // Android: forzar Chrome con intent URL.
      var btnAbrir = document.createElement('button');
      btnAbrir.type = 'button';
      btnAbrir.className = 'chagual-inapp-btn chagual-inapp-btn--primary';
      btnAbrir.textContent = TEXTOS.botonAbrir;
      btnAbrir.addEventListener('click', abrirEnChromeAndroid);
      actions.appendChild(btnAbrir);
    } else {
      // iOS (o desconocido): no se puede forzar; ofrecer copiar enlace.
      var btnCopiar = document.createElement('button');
      btnCopiar.type = 'button';
      btnCopiar.className = 'chagual-inapp-btn chagual-inapp-btn--primary';
      btnCopiar.textContent = TEXTOS.botonCopiar;
      btnCopiar.addEventListener('click', function () {
        copiarEnlace(btnCopiar);
      });
      actions.appendChild(btnCopiar);
    }

    sheet.appendChild(row);
    sheet.appendChild(actions);

    function cerrar() {
      marcarCerrado();
      document.removeEventListener('keydown', cerrarConEscape);
      if (sheet && sheet.parentNode) {
        sheet.parentNode.removeChild(sheet);
      }
    }

    function cerrarConEscape(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        cerrar();
      }
    }

    document.body.appendChild(sheet);
  }

  if (document.body) {
    construirBanner();
  } else {
    document.addEventListener('DOMContentLoaded', construirBanner);
  }
})();
